import { OfflineWritesRetiredBanner } from "./OfflineWritesRetiredBanner";
import { PwaStatusBanner } from "./PwaStatusBanner";
import { SyncStatusBanner } from "./SyncStatusBanner";

/**
 * Where transient system notices live, between the shell chrome and the route.
 *
 * The connection and storage notices are mutually exclusive by construction, so
 * at most two strips can ever appear: one about the connection, one about the
 * application itself. The application status stays a separate landmark because
 * it is independently addressable -- an update prompt must remain findable even
 * while the device is offline.
 */
export function SystemBannerRegion({ isOnline }: { isOnline: boolean }) {
  return (
    <div className="system-banner-region">
      <SyncStatusBanner isOnline={isOnline} />
      <OfflineWritesRetiredBanner />
      <PwaStatusBanner />
    </div>
  );
}
